<template>
    <button v-if="!showOnlyContent" :class="'collapse-button ' + (open ? 'open ' : 'closed ') + buttonClass"
        ref="button"
        type="button" 
        data-bs-toggle="collapse" 
        :data-bs-target="`#${id}`" 
        aria-expanded="false" 
        :aria-controls="id"
        @click="() => open = !open"
        >
        <slot name="button-content-before-icon"/>
        <Icon v-if="iconTypeOpen && iconTypeClosed" class="icon-open-close" :type="open ? iconTypeOpen : iconTypeClosed"/>
        <Icon v-else-if="iconTypeOpen" class="icon-open" :type="iconTypeOpen"/>
        <Icon v-else-if="iconTypeClosed" class="icon-close" :type="iconTypeClosed"/>
        <slot name="button-content-after-icon"/>
    </button>
    <div v-if="!showOnlyContent" :class="'collapse' + (collapseHorizontal ? ' collapse-horizontal' : '')" :id="id" ref="collapse">
        <slot name="collapse-content"/>
    </div>

    <slot v-if="showOnlyContent" name="collapse-content"/>
</template>
<script>
import Icon from '../image/icon.vue';
import { Collapse } from 'bootstrap';

export default {
    name: "Collapse",
    props: {
        id: String,
        buttonClass: {
            type: String,
            required: false,
            default: "d-flex",
        },
        iconTypeOpen: {
            type: String,
            required: false,
            default: "chevron-up",
        },
        iconTypeClosed: {
            type: String,
            required: false,
            default: "chevron-down",
        },
        open: {
            type: Boolean,
            required: false,
            default: false,
        },
        showOnlyContent: {
            type: Boolean,
            required: false,
            default: false,
        },
        collapseHorizontal: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    emits: ['isOpen'], 
    components: {
        Icon
    },
    data: function () {
        return {
            bsCollapse: null,
        };
    },
    mounted() {
        if(this.$refs.collapse) {
            this.bsCollapse = new Collapse(this.$refs.collapse, { toggle: this.open });
        }
    },
    updated() {
        if(this.bsCollapse != null) {
            if(this.open) {
                this.bsCollapse.show();
            } else {
                this.bsCollapse.hide();
            }
        }
    },
    watch: {
        open: function() {
            this.$emit('isOpen', this.open);
        }
    }
};
</script>